// extracted by mini-css-extract-plugin
export var arrow = "DocumentCard-module--arrow--140cb";
export var arrowNo = "DocumentCard-module--arrow_no--de94b";
export var arrowYes = "DocumentCard-module--arrow_yes--f5f4a";
export var corner = "DocumentCard-module--corner--27ced";
export var documentCard = "DocumentCard-module--documentCard--4cf37";
export var flex = "DocumentCard-module--flex--78c25";
export var flex1 = "DocumentCard-module--flex_1--fb9d1";
export var flexCenter = "DocumentCard-module--flex_center--3e336";
export var flexCenterCol = "DocumentCard-module--flex_center_col--4487e";
export var flexCol = "DocumentCard-module--flex_col--12dcc";
export var flexFixCenterCol = "DocumentCard-module--flex_fix_center_col--bc0ab";
export var flexFixedCenterCol = "DocumentCard-module--flex_fixed_center_col--51723";
export var image = "DocumentCard-module--image--cbe4e";
export var inCache = "DocumentCard-module--inCache--a697e";
export var libraryButton = "DocumentCard-module--libraryButton--0c2ae";
export var libraryIcon = "DocumentCard-module--libraryIcon--ab43f";
export var linkButton = "DocumentCard-module--linkButton--8256b";
export var moreButton = "DocumentCard-module--moreButton--0f806";
export var overlay = "DocumentCard-module--overlay--3679f";
export var overlayBottomRow = "DocumentCard-module--overlayBottomRow--1518a";
export var overlayContentType = "DocumentCard-module--overlayContentType--b1ea3";
export var overlayTopRow = "DocumentCard-module--overlayTopRow--5f134";
export var playButton = "DocumentCard-module--playButton--5a4e8";
export var publishingContainer = "DocumentCard-module--publishingContainer--74d07";
export var publishingInformationLabel = "DocumentCard-module--publishingInformationLabel--cea5c";
export var rotating = "DocumentCard-module--rotating--3eb36";
export var title = "DocumentCard-module--title--cccca";